<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="id/昵称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="电话">
								<a-input v-model="queryParams.phone" placeholder="电话" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="科目">
								<a-select v-model="queryParams.subject" allowClear placeholder="请选择科目" style="width: 100%">
									<a-select-option v-for="item in scoreSubjectOptions" :key="item.value" :value="item.value">
										{{ item.label }}
									</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="变动类型">
								<a-select v-model="queryParams.changeType" placeholder="" default-value="">
									<a-select-option value="income">收入</a-select-option>
									<a-select-option value="expend">支出</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				<template slot="user" slot-scope="record">
					<div class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.avatarUrl || ''" width="48" height="48" alt="" @click="openUserDetail(record.userId)" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.nickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.sex === 'MALE'">男</span>
								<span class="user-right-detail" v-else-if="record.sex === 'FEMALE'">女</span>
								<span class="user-right-detail" v-if="record.age != null && record.age !== ''">{{ record.age }}岁</span>
								<span class="user-right-detail">{{ record.province }}{{ record.city }}</span>
							</p>
						</div>
					</div>
				</template>

				<template slot="subject" slot-scope="record">
					<div class="complex">
						<span>{{ subjectCellText(record) }}</span>
					</div>
				</template>

				<template slot="changeAmount" slot-scope="record">
					<div class="complex">
						<span v-if="record.amount>0" class="income-span">{{ record.amount }}</span>
						<span v-else class="expend-span">{{ record.amount }}</span>
					</div>
				</template>
				
				<template slot="balance" slot-scope="record">
					<div class="complex">
						<span>{{ record.balanceAfter }}</span>
					</div>
				</template>
				
				<template slot="remark" slot-scope="record">
					<div class="complex">
						<span>{{ record.remark }}</span>
					</div>
				</template>
				
				<template slot="action" slot-scope="record">
					<a @click="viewDetail(record.id)">查看</a>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>

		</a-card>
		<user-detail-drawer ref="userDetailDrawer" />
	</div>
</template>

<script>
	import moment from "moment";
	import { userScoreList } from "@/api/op/user.js";
	import UserDetailDrawer from "@/components/UserDetailDrawer.vue";
	import dict from "@/config/dict.js";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id',
		},
		{
			title: '用户',
			scopedSlots: {
				customRender: 'user'
			}
		},
		{
			title: '科目',
			scopedSlots: {
				customRender: 'subject'
			}
		},
		{
			title: '变动积分',
			scopedSlots: {
				customRender: 'changeAmount'
			}
		},
		{
			title: '变动后积分',
			scopedSlots: {
				customRender: 'balance'
			}
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			UserDetailDrawer,
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				formVisible: false,
				formLoading: false,
				formModel: null,
				createTime:[]
			}
		},
		computed: {
			scoreSubjectOptions() {
				return dict.score || [];
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				userScoreList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;
					this.tableLoading = false;
				});
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			rest() {
				this.createTime = [];
				this.queryParams={}
			},
			viewDetail(id) {
				console.log('------viewDetail', id);
			},
			openUserDetail(id) {
				if (this.$refs.userDetailDrawer) {
					this.$refs.userDetailDrawer.open(id);
				}
			},
			dictLabel(arr, value) {
				if (value == null || value === '') return '-';
				const item = (arr || []).find(d => d.value == value);
				return item ? item.label : value;
			},
			subjectCellText(record) {
				if (record.subject != null && record.subject !== '') {
					return this.dictLabel(this.scoreSubjectOptions, record.subject);
				}
				return record.subjectText || '-';
			}
		}
	}
</script>

<style lang="less" scoped>
	.user {
		display: flex;
		flex-direction: row;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 8px;
			text-align: center;

			.cover-img {
				border-radius: 4px;
				object-fit: cover;
				cursor: pointer;
			}
		}

		.user-right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			
			p.first {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}

				.user-id {
					font-size: 12px;
					color: #acacac;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}

			.user-right-detail {
				margin-right: 5px;
			}
		}
	}

	.complex {
		display: flex;
		flex-direction: column;

		p {
			margin: 0;
		}
	}

	.assist {
		font-size: 12px;
		color: #acacac;
	}

	.income-span {
		color: #00b900;
	}

	.expend-span {
		color: #ff0000;
	}
</style>